import { quantityOrderedStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import { css } from "styled-components";

quantityOrderedStyles.quantityOrdered = {
    cssOverrides: {
        formField: css`
            margin-top: 0px;
            position: relative;
            > div[class^="FormInputWrapper"] {
                margin-top: 0px !important;
            }
        `,
        inputSelect: css`
            padding-left: 40px;
            &:focus {
                padding-left: 40px;
            }
        `,
    },
    labelProps: {
        css: css`
            position: absolute;
            z-index: 9;
            top: 9px;
            left: 5px;
            width: auto;
        `,
    },
};
